module.exports = __webpack_public_path__ + "static/media/defaultImg.18641a56.png";